<div class="fixed top-0 left-0 w-screen h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#597A4F] via-[#85a277] to-[#adc4a4] text-white font-['Inter']">
  <!-- Background decoration -->
  <div class="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.08)_0%,transparent_50%),radial-gradient(circle_at_70%_80%,rgba(255,255,255,0.05)_0%,transparent_50%)] animate-pulse"></div>

  <div class="relative z-10 flex flex-col items-center gap-8 max-w-md mx-auto px-6 text-center">
    <!-- Logo -->
    <div class="relative bg-white/95 rounded-3xl p-6 shadow-2xl backdrop-blur-sm border-2 border-white/40">
      <img
        src="assets/img/logo_sygnet.svg"
        alt="Ekowitryna"
        class="w-24 h-24 object-contain"
      />
      <!-- Error indicator -->
      <div class="absolute -bottom-1 -right-1 w-8 h-8 bg-red-500 rounded-full border-3 border-white shadow-lg flex items-center justify-center">
        <i class="pi pi-times text-white text-sm font-bold"></i>
      </div>
    </div>

    <!-- Title -->
    <h1 class="text-3xl font-semibold text-white drop-shadow-lg tracking-wide" *ngIf="translationsLoaded">
      {{ authorized ? ('errorPages.404.pageNotFound' | translate) : ('errorPages.unauthorized.accessDenied' | translate) }}
    </h1>
    <h1 class="text-3xl font-semibold text-white drop-shadow-lg tracking-wide" *ngIf="!translationsLoaded">
      {{ authorized ? '404' : 'Odmowa dostępu' }}
    </h1>

    <!-- Description -->
    <p class="text-lg text-white/90 leading-relaxed drop-shadow-sm" *ngIf="translationsLoaded">
      {{ authorized ? ('errorPages.404.pageIsntAvailable' | translate) : ('errorPages.unauthorized.noAuthorization' | translate) }}
    </p>
    <p class="text-lg text-white/90 leading-relaxed drop-shadow-sm" *ngIf="!translationsLoaded">
      {{ authorized ? 'Strona nie została znaleziona' : 'Nie masz uprawnień do przeglądania tej strony' }}
    </p>

    <!-- Button -->
    <div class="flex flex-col sm:flex-row items-center gap-4 mt-4">
      <button
        pButton
        type="button"
        [label]="translationsLoaded ? (authorized ? ('errorPages.404.buttonText' | translate) : 'Powrót do strony głównej') : 'Powrót do strony głównej'"
        icon="pi pi-home"
        class="bg-white/20 hover:bg-white/30 border-2 border-white/40 hover:border-white/60 text-white font-semibold px-8 py-3 rounded-xl backdrop-blur-sm transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
        [routerLink]="authorized ? '/' : '/dashboard'">
      </button>
    </div>
  </div>
</div>
